module.exports = __webpack_public_path__ + "img/download_icon.4fe4c05b.svg";